var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3065 32.9504C16.6276 32.0273 15.963 31.1256 15.3237 30.2132C13.1253 27.0881 11.0922 23.8624 9.45056 20.4032C8.64593 18.7041 7.90595 16.9727 7.54674 15.1228C6.86783 11.6528 7.67247 8.53488 10.0217 5.88032C12.2883 3.32633 15.1907 2.1553 18.5961 2.2954C23.3484 2.49296 27.4973 6.06711 28.4636 10.7404C28.8587 12.6586 28.7294 14.5337 28.1403 16.4016C26.9585 20.1158 25.1085 23.496 22.9928 26.7361C21.4805 29.0494 19.8353 31.2765 18.2476 33.5395C18.2081 33.5934 18.1686 33.6437 18.1147 33.7048C18.0357 33.791 17.6765 33.4533 17.3065 32.9504ZM23.2263 13.1292C23.3664 10.4243 21.1213 7.90267 18.438 7.7554C15.3416 7.58298 12.9421 9.73824 12.7768 12.8526C12.6332 15.5575 14.9285 18.0683 17.6693 18.1976C20.6831 18.3413 23.0718 16.1573 23.2263 13.1292Z",
    fill: "#1B4DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin1);
export default __webpack_public_path__ + "static/media/location-pin 1.6951d7ffb86a401a0ba566cca6e8e446.svg";
export { ForwardRef as ReactComponent };